export default __webpack_public_path__ + "static/icon-globe-b2991aa40bc7a181521a64e5abeee301.png";